import React , { Component } from 'react'
import axios from 'axios'
import moment from 'moment'
import { Calendar, momentLocalizer } from 'react-big-calendar'
import { format } from 'date-fns'
import { APIURL } from '../../config/config'
import { AlertMessage } from '../Alert/Alert'

const localizer = momentLocalizer(moment)
require ("react-big-calendar/lib/css/react-big-calendar.css");

class CustomerFollowupCalendar extends Component {
  constructor (props) {
    super(props);
    this.state = {
      followups: [],
      calendars: [],
      salespersons: [], // << เพิ่ม state สำหรับเก็บรายชื่อพนักงานขาย
      selectedSalesperson: "all", // << เพิ่ม state สำหรับเก็บพนักงานขายที่เลือก
      followup_by: ""
    }
    this.loadCustomerFollowup = this.loadCustomerFollowup.bind(this)
    this.getContent = this.getContent.bind(this)
    this.eventStyleGetter = this.eventStyleGetter.bind(this)
    this.loadSalespersons = this.loadSalespersons.bind(this);
  }

  componentDidMount () {
    //this.loadCustomerFollowup()
    //this.loadSalespersons();
    if (this.props.user && this.props.user.type === 'admin') {
      this.loadSalespersons(); // << โหลดรายชื่อพนักงานขายถ้าเป็น admin
    }
    this.loadCustomerFollowup();
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (prevProps.isReload !== this.props.isReload) {
      if(this.props.isReload) {
        this.loadCustomerFollowup()
      }
    }

    // ถ้า selectedSalesperson เปลี่ยนไป ให้โหลดข้อมูลใหม่ (สำหรับ admin)
    if (this.props.user && this.props.user.type === 'admin' && prevState.selectedSalesperson !== this.state.selectedSalesperson) {
      this.loadCustomerFollowup();
    }
  }

  loadSalespersons() {
    axios
        .get(APIURL + "/account/")
        .then((res) => {
          this.setState({ salespersons: res.data });
        })
        .catch((error) => {
          this.setState({ salespersons: [] });
        });
  }

  loadCustomerFollowup() {
    const { user } = this.props;
    const { selectedSalesperson } = this.state;
    let username = this.props.user.user
    let type = this.props.user.type
    let uri = ''

    if(type !== 'admin') {
      uri = APIURL+'/customer/followup/last/'+username;
      // uri = APIURL+'/customer/followup/last/admin';
    } else {
      //เฉพาะสิทธิ์ Admin
      if(selectedSalesperson === "all"){
        uri = APIURL+'/customer/followup/last/admin';
      } else {
        uri = APIURL+'/customer/followup/last/'+selectedSalesperson;
      }
    }

  axios.get(uri).then(res => {

      let followups = res.data

      let calendars = followups.map((followup, index) => {
        // followup_times  followup_detail followup_next
        // let followup_times = followup.followup_times
        // let followup_detail = followup.followup_detail
        // let customer_mobile = followup.customer_mobile
        let followup_next = followup.followup_next
        let customer_fullname = followup.customer_name+' '+followup.customer_lastname

        let content = this.getContent(followup)

        let title = 'ชื่อ : '+customer_fullname+'\n'
        title += 'หัวข้อติดตาม : '+followup_next

        let followup_color = followup.followup_color
        //console.log('followup_color==', followup_color)

        let calendar = {
          title: title,
          start: followup.followup_date,
          end: followup.followup_date,
          hex_color: followup_color || '5EBA7D',
          content: content,
        }
        return calendar
      })
      this.setState({
        followups: res.data,
        calendars: calendars
      }, () => this.props.onStopReload())
    })
  }

  getContent(followup) {
    let followup_times = followup.followup_times
    let followup_detail = followup.followup_detail
    let followup_next = followup.followup_next
    let customer_fullname = followup.customer_name+' '+followup.customer_lastname
    let customer_mobile = followup.customer_mobile
    let contact_date = format(new Date(followup.contact_date), 'dd/MM/yyyy')
    let followup_date = format(new Date(followup.followup_date), 'dd/MM/yyyy')
    let followup_by = followup.followup_by
    let customer_type_name = followup.customer_type_name
    //console.log('customer_type_name==', customer_type_name)

    // contact_date followup_date

    let content = '<table cellpadding="10"><tbody>'
    //content += '<tr><td class="text-left font-sm"> ครั้งที่ : </td><td class="text-left font-sm">'+followup_times+'</td></tr>'
    content += '<tr><td class="text-left font-sm"> สถานะติดตาม : </td><td class="text-left font-sm">'+customer_type_name+'</td></tr>'
    content += '<tr><td class="text-left font-sm"> วันที่ติดต่อ : </td><td class="text-left font-sm">'+contact_date+'</td></tr>'
    content += '<tr><td class="text-left font-sm"> วันที่นัดหมาย : </td><td class="text-left font-sm">'+followup_date+'</td></tr>'
    content += '<tr><td class="text-left font-sm"> รายละเอียด : </td><td class="text-left font-sm">'+followup_detail+'</td></tr>'
    content += '<tr><td class="text-left font-sm" width="120px"> หัวข้อติดตาม : </td><td class="text-left font-sm">'+followup_next+'</td></tr>'
    content += '<tr><td class="text-left font-sm"> ลูกค้า : </td><td class="text-left font-sm">'+customer_fullname+'</td></tr>'
    content += '<tr><td class="text-left font-sm"> โทร. : </td><td class="text-left font-sm">'+customer_mobile+'</td></tr>'
    content += '<tr><td class="text-left font-sm"> ติดตามโดย. : </td><td class="text-left font-sm">'+followup_by+'</td></tr>'
    content += '</tbody></table>'

    return content

  }

  eventStyleGetter(event, start, end, isSelected) {
    let backgroundColor = '#' + event.hex_color;
    let style = {
      backgroundColor: backgroundColor,
      borderRadius: '5px',
      opacity: 0.8,
      color: 'white',
      border: '0px',
      display: 'block',
    };
    return {
      style: style
    };
  }

  render () {
    const { salespersons } = this.state;

    let salespersons_list = salespersons.map((salesperson, index) => (
        <option key={index} value={salesperson.user}>
          {salesperson.user}
        </option>
    ));

    return (
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-block">
                <div className="row">
                  <div className="col-sm-12 col-md-12">
                    <div className="card card-accent-info">
                      <div className="card-header">
                        <div className="row">
                          <div className="mt-1 ml-3">
                            <strong className="text-title"> ดูตามผู้ติดตาม </strong>
                          </div>

                              <div className="form-group col-md-4">
                                <select
                                    className="form-control"
                                    name="selectedSalesperson"
                                    value={this.state.selectedSalesperson}
                                    onChange={(e) => {
                                      let value = e.target.value;
                                      this.setState({
                                        selectedSalesperson: value,
                                      },() => this.loadCustomerFollowup());
                                    }}
                                >
                                  <option value="all">เลือกผู้ติดตาม</option>
                                  {salespersons_list}
                                </select>
                              </div>
                        </div>
                      </div>

                        <div className="card-block">
                          <Calendar
                            localizer={localizer}
                            selectable
                            style={{height: '960px' , backgroundColor:'#ffffff'}}
                            events={this.state.calendars}
                            defaultView='month'
                            defaultDate={new Date()}
                            onSelectEvent={event => AlertMessage(event.content)}
                            eventPropGetter={(this.eventStyleGetter)}
                          />
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    )
  }
}

export default CustomerFollowupCalendar
